import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

export default function MarketingNavbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-[var(--mp-border)]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-2.5 group"
        >
          <div
            aria-label="Marketing Parrucchieri"
            className="h-10 w-10 rounded-xl"
            style={{
              backgroundImage:
                "image-set(url(/img/logo-80.webp) 1x, url(/img/logo-160.webp) 2x, url(/img/logo-320.webp) 3x)",
              backgroundSize: "200% auto",
              backgroundPosition: "center top",
              backgroundRepeat: "no-repeat",
            }}
          />
          <div className="leading-tight">
            <div className="font-display text-[15px] font-semibold tracking-tight">
              Marketing Parrucchieri
            </div>
            <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-[var(--mp-muted)]">
              SRL · Social Agency
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[var(--mp-muted)]">
          <a href="#servizi" className="hover:text-[var(--mp-ink)] transition-colors">
            Servizi
          </a>
          <a href="#agenzia" className="hover:text-[var(--mp-ink)] transition-colors">
            Agenzia
          </a>
          <a href="#cliente" className="hover:text-[var(--mp-ink)] transition-colors">
            Cliente
          </a>
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Button
                variant="ghost"
                className="rounded-full"
                data-testid="navbar-dashboard-btn"
                onClick={() => navigate("/dashboard")}
              >
                Dashboard
              </Button>
              <Button
                data-testid="navbar-logout-btn"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                className="rounded-full bg-[var(--mp-ink)] hover:bg-black text-white"
              >
                Esci
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                data-testid="navbar-agency-login-btn"
                onClick={() => navigate("/agenzia/login")}
                className="rounded-full hidden sm:inline-flex"
              >
                Agenzia
              </Button>
              <Button
                data-testid="navbar-client-login-btn"
                onClick={() => navigate("/cliente/login")}
                className="rounded-full bg-[var(--mp-primary)] hover:bg-[var(--mp-primary-hover)] text-white"
              >
                Area Cliente
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
